<template>
  <div class="overview-data" v-loading="cardArealoading">
    <div class="data-screening">
      <div class="date-wrap">
        统计周期： <span class="date-value">{{ returnsOverview.date }}</span>
      </div>
      <div class="data-wrap">
        <div
          @click="changeCard(0, 15)"
          :class="[activeLabel == 0 ? 'data-item active' : 'data-item']"
        >
          <p class="item-title">本月累计收入</p>
          <div class="figure-detail">
            <span class="item-figure">{{
              returnsOverview.money | regroupWan(3)
            }}</span>
            <!-- <span class="item-detail" @click="openDetailCard(1)">详情</span> -->
          </div>
          <p class="item-prev">昨日 {{ returnsOverview.yesterday_money }}</p>
        </div>
        <div
          @click="changeCard(1, 11)"
          :class="[activeLabel == 1 ? 'data-item active' : 'data-item']"
        >
          <p class="item-title">本月迷你豆收入</p>
          <div class="figure-detail">
            <span class="item-figure">{{
              returnsOverview.minibean | regroupWan
            }}</span>
            <!-- <span class="item-detail" @click="openDetailCard(1)">详情</span> -->
          </div>
          <p class="item-prev">
            昨日 {{ returnsOverview.yesterday_minibean | regroupWan }}
          </p>
        </div>
      </div>

      <div class="data-wrap">
        <!-- <div class="earnings-wrap card"> -->
        <div
          @click="changeCard(2, 9)"
          :class="[activeLabel == 2 ? 'data-item active' : 'data-item']"
        >
          <p class="item-title">广告总收入（预估）</p>
          <div class="figure-detail">
            <span class="item-figure">{{
              returnsOverview.ad_income | regroupComma(2)
            }}</span>
            <!-- <span class="item-detail" @click="openDetailCard(1)">详情</span> -->
          </div>
          <p class="item-prev">
            昨日 {{ returnsOverview.yesterday_ad_income | regroupComma(2) }}
          </p>
        </div>
        <div
          @click="changeCard(7, 14)"
          :class="[activeLabel == 7 ? 'data-item active' : 'data-item']"
        >
          <p class="item-title">广告曝光总次数</p>
          <div class="figure-detail">
            <span class="item-figure">{{ returnsOverview.ad_count || 0 }}</span>
            <!-- <span class="item-detail" @click="openDetailCard(1)">详情</span> -->
          </div>
          <p class="item-prev">
            昨日 {{ returnsOverview.yesterday_ad_count || 0 }}
          </p>
        </div>
        <div
          @click="changeCard(4, 10)"
          :class="[activeLabel == 4 ? 'data-item active' : 'data-item']"
        >
          <p class="item-title">贡献点收入</p>
          <div class="figure-detail">
            <span class="item-figure">{{
              returnsOverview.contribution | regroupComma(3)
            }}</span>
          </div>
          <p class="item-prev">
            昨日 {{ returnsOverview.yesterday_contribution | regroupComma(3) }}
          </p>
        </div>
        <!-- <i class="data-line"></i> -->
        <div
          @click="changeCard(3, 12)"
          :class="[activeLabel == 3 ? 'data-item active' : 'data-item']"
        >
          <p class="item-title">迷你点收入</p>
          <div class="figure-detail">
            <span class="item-figure">{{
              returnsOverview.minipoint | regroupComma(2)
            }}</span>
            <!-- <span class="item-detail" @click="openDetailCard(2)">详情</span> -->
          </div>
          <p class="item-prev">
            昨日 {{ returnsOverview.yesterday_minipoint | regroupComma(2) }}
          </p>
        </div>
        <!-- </div> -->
        <!-- <div class="income-wrap card"> -->

        <div
          @click="changeCard(5, 13)"
          :class="[activeLabel == 5 ? 'data-item active' : 'data-item']"
        >
          <p class="item-title">激励金总收入</p>
          <div class="figure-detail">
            <span class="item-figure">{{
              returnsOverview.other | regroupComma(2)
            }}</span>
            <!-- <span class="item-detail" @click="openDetailCard(1)">详情</span> -->
          </div>
          <p class="item-prev">
            昨日 {{ returnsOverview.yesterday_other | regroupComma(2) }}
          </p>
        </div>

        <!-- <div
          @click="changeCard(8)"
          :class="[activeLabel == 8 ? 'data-item active' : 'data-item']"
        >
          <p class="item-title">会员免广告曝光总次数</p>
          <div class="figure-detail">
            <span class="item-figure">{{
              returnsOverview.other_money | regroupWan(3)
            }}</span>
          </div>
          <p class="item-prev">
            昨日 {{ returnsOverview.before_other_money || 0 }}
          </p>
        </div> -->
        <!-- </div> -->
      </div>
      <div id="charts">
        <!-- <p class="charts-title">{{ getChartTitle }}</p> -->
        <ve-line
          :extend="chartExtend"
          v-if="chartData.rows.length"
          :data="chartData"
          :legend-visible="false"
        >
        </ve-line>
        <div class="img-no-data" v-else>
          <img src="../../../../assets/images/img_map_no_data.png" />
          <p>您暂时还没有数据呢~</p>
        </div>
      </div>
      <div class="data-explain">
        <p>1. 以上收益数据为自然月的收入概览数据。</p>
        <p>
          2.
          由于广告数据受广告商报价时间递延影响，因此广告总收入为预估收入，由广告曝光总次数预估所得。
        </p>
        <p>3. 收益数据将在次日10点更新。</p>
        <p>
          4.
          若您已加入工作室并成为签约成员，此处收益为归属您个人账号的收益。成为签约成员后的收益将直接计入工作室收益之中。
        </p>
        <p>
          5.
          若您成立签约工作室成为签约室长，您在当月的个人收益将划入工作室收益之中，请做好收益区分。
        </p>
      </div>
    </div>
    <el-dialog :visible.sync="detailDialogVisible" width="600px" center>
      <div class="dialog-wrap">
        <div class="dialog-tital">{{ dialogTitle }}收益合计</div>
        <p class="dialog-total">{{ cardDetail.total_income | regroupWan }}</p>
        <i class="division-line"></i>
        <div class="dialog-detail">
          <template v-if="cardDetail.total_income">
            <p class="income-list">
              <span>广告收入</span>
              <span>
                {{ cardDetail.ad_income | regroupComma(2) }}
              </span>
            </p>
            <p class="income-list">
              <span>贡献点</span>
              <span>
                {{ cardDetail.contribution | regroupComma(3) }}
              </span>
            </p>
            <p class="income-list">
              <el-tooltip
                content="按照兑换比例折算后的迷你点收入"
                placement="bottom"
              >
                <span class="income-list-name">
                  迷你点收入<img
                    class="icon"
                    src="@/assets/images/icon_help.png"
                /></span>
              </el-tooltip>
              <span>
                {{ cardDetail.minipoint | regroupComma(2) }}
              </span>
            </p>
            <p class="income-list">
              <span>其他</span>
              <span>
                {{ cardDetail.other | regroupComma(2) }}
              </span>
            </p>
          </template>
          <img
            v-if="!cardDetail.total_income"
            src="@/assets/images/img_dialog_no_data.png"
          />
          <p>
            {{
              cardDetail.total_income
                ? `当前账号下${dialogTitle}获得的收益总额，其中广告收入为预估收入，请以实际入账金额为准`
                : '暂无收入，快去上传地图或资源吧'
            }}
          </p>
          <a
            target="_blank"
            v-if="!cardDetail.total_income"
            href="https://dev-wiki.mini1.cn/cyclopdeia.html"
            >开发者创作教程 ></a
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getIncomeOverview,
  getIncomeCard,
  getIncomeDiagram,
} from '@/api/income';
import { chartExtend } from '@/views/charts/components/chartsStyle';
export default {
  name: 'overviewCard',
  data() {
    return {
      cardArealoading: false,
      detailDialogVisible: false,
      dialogTitle: '本月',
      isShowCard: false,
      cardDetail: {},
      dateValue: '',
      activeLabel: 0,
      grid: {
        left: 15,
        right: 20,
      },
      isShowChartDefault: false,
      chartExtend: chartExtend,
      overviewList: [], //存储近1个月的卡片数据
      storDetailCard: {}, // 暂存卡片信息，点击卡片再请求，dialog会比较慢
      returnsOverview: {},
      dateList: [], //定义近一个月的年月日
      chartData: {
        columns: ['日期', '数据'],
        rows: [],
      },
    };
  },
  filters: {
    regroupWan(num, toFixed) {
      if (num >= 10000) {
        return (num / 10000).toFixed(toFixed || 2) + '万';
      } else if (`${num}`.includes('.')) {
        return num.toFixed(toFixed || 2);
      } else {
        return toFixed ? Number(num).toFixed(toFixed) : num;
      }
    },
    regroupComma(val, num) {
      if (val) {
        let str = val.toString().includes('.')
          ? val.toFixed(num).toString()
          : val.toString();
        let reg =
          str.indexOf('.') > -1
            ? /(\d)(?=(\d{3})+\.)/g
            : /(\d)(?=(?:\d{3})+$)/g;
        let res = str.replace(reg, '$1,');
        return res;
      } else return val;
    },
  },
  mounted() {
    this.fetchIncomeOverview();
    //this.fetchIncomeCard(1);
    //this.fetchIncomeCard(2);
    //收益概览曝光埋点
    this.init();
    this.reOverviewShow();
    //  this.getMonthDateData();
    /**判断当前日期是否小于7 */
    if (new Date().getDate() < 7) {
      this.getWeekDateData();
    } else {
      this.getNatureMonthDay();
    }
    this.grid = {
      left: 15,
      right: 20,
    };
  },
  computed: {
    // getChartTitle() {
    //   let title = '';
    //   switch (this.activeLabel) {
    //     case 0:
    //       title = '过去30日收益变化';
    //       break;
    //     case 1:
    //       title = '过去30日地图浏览数变化';
    //       break;
    //     case 2:
    //       title = '过去30日玩家游玩数变化';
    //       break;
    //     case 3:
    //       title = '过去30日玩家游玩时间变化';
    //       break;
    //     case 4:
    //       title = '过去30日评论数变化';
    //       break;
    //     case 5:
    //       title = '过去30日投块数变化';
    //       break;
    //     case 6:
    //       title = '过去30日点赞数变化';
    //       break;
    //     case 7:
    //       title = '过去30日收藏数变化';
    //       break;
    //     default:
    //       break;
    //   }
    //   return title;
    // }
    countTime() {
      const date = new Date();
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth();
      const year = date.getFullYear();
      //判断当前日期是否为1号，1号则展示上个月的周期，反之则展示自然月
      let lastDate = new Date();
      lastDate.setTime(lastDate.getTime() - 24 * 60 * 60 * 1000);
      const lastMonth =
        lastDate.getMonth() + 1 < 10
          ? '0' + (lastDate.getMonth() + 1)
          : lastDate.getMonth();
      const lastYear = lastDate.getFullYear();
      const lastDay = lastDate.getDate();
      let day1 =
        date.getDate() - 1 < 10
          ? '0' + (date.getDate() - 1)
          : date.getDate() - 1;
      let startDate = '';
      let endDate = '';
      if (date.getDate() === 1) {
        startDate = lastYear + '年' + lastMonth + '月' + '01' + '日';
        endDate = lastYear + '年' + lastMonth + '月' + lastDay + '日';
      } else {
        startDate = year + '年' + month + '月' + '01' + '日';
        endDate = year + '年' + month + '月' + day1 + '日';
      }
      let res = '';
      res = startDate + '-' + endDate;
      return res;
    },
  },
  methods: {
    changeCard(index, dtype) {
      this.activeLabel = index;
      this.fetchIncomeDiagram(dtype);
      // this.getChartsData();
    },
    init() {
      this.chartData = {
        columns: ['日期', '数据'],
        rows: [
          { 日期: '2021-10-10', 数据: 35 },
          { 日期: '2021-10-13', 数据: 65 },
          { 日期: '2021-10-16', 数据: 25 },
          { 日期: '2021-10-19', 数据: 85 },
          { 日期: '2021-10-22', 数据: 25 },
          { 日期: '2021-10-25', 数据: 10 },
          { 日期: '2021-10-28', 数据: 25 },
          { 日期: '2021-10-31', 数据: 85 },
          { 日期: '2021-11-03', 数据: 66 },
          { 日期: '2021-11-06', 数据: 75 },
          { 日期: '2021-11-07', 数据: 0 },
          { 日期: '2021-11-08', 数据: 0 },
        ],
      };
      this.fetchIncomeDiagram(15, 0);
      //获取卡片数据数组
      // this.fetchMapOverview();
    },
    // 获取收益折现数据
    async fetchIncomeDiagram(dtype) {
      try {
        const res = await getIncomeDiagram({
          dtype: dtype,
        });
        this.getChartsData(res.data.list, dtype);
      } catch (error) {
        console.log(error);
      }
    },
    //获取近一个月的年月日，其他默认数据为0
    getMonthDateData() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - 30);
      while (endDate.getTime() - startDate.getTime() > 0) {
        let year = startDate.getFullYear();
        let month =
          startDate.getMonth() + 1 < 10
            ? '0' + (startDate.getMonth() + 1)
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate() < 10
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    //当日期小于7时，获取近一周的年月日，并将其他值初始化为0
    getWeekDateData() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - 7);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    /**
     * 获取自然月的年月日，其他默认数据为0
     * 当前日期小于1周展示近三天的数据
     **/
    getNatureMonthDay() {
      let arr = [];
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(endDate.getDate() - new Date().getDate() + 1);
      while (endDate.getTime() - startDate.getTime() >= 0) {
        let year = startDate.getFullYear();
        let month =
          (startDate.getMonth() + 1).toString().length === 1
            ? '0' + (startDate.getMonth() + 1).toString()
            : startDate.getMonth() + 1;
        let day =
          startDate.getDate().toString().length === 1
            ? '0' + startDate.getDate()
            : startDate.getDate();
        arr.push({
          date: year + '-' + month + '-' + day,
          block: 0,
          browse: 0,
          collect: 0,
          comment: 0,
          download: 0,
          play_count: 0,
          play_time: '0',
          praise: 0,
        });
        startDate.setDate(startDate.getDate() + 1);
      }
      this.dateList = arr.slice(0, arr.length - 1);
    },
    //获取折线图数据
    getChartsData(list, dtype) {
      this.chartData.rows = [];
      // this.chartsTitle = this.overviewData[this.activeCard].title;
      if (list.length) {
        this.dateList.forEach(date => {
          list.forEach(item => {
            if (date.date == item.date) {
              date = item;
            }
          });
          this.chartData.rows.push({
            日期: date.date,
            数据: dtype == 4 ? Number(date.num / 60).toFixed(2) : date.num || 0,
          });
        });
      }
    },
    //收益概览曝光埋点
    reOverviewShow() {
      this.$log('revenue_overview_show', 85419, { v7: 1 });
    },
    //本月收益详情点击埋点
    monthDClick() {
      this.$log('thismonth_revenue_details_click', 85420, { v7: 1 });
    },
    //累计收益详情点击埋点
    allDClick() {
      this.$log('cumulative_revenue_details_click', 85421, { v7: 1 });
    },
    //获取首页收益概览
    async fetchIncomeOverview() {
      this.cardArealoading = true;
      try {
        const res = await getIncomeOverview();
        this.returnsOverview = res.data;
        this.isShowCard = true;
        this.cardArealoading = false;
      } catch (error) {
        this.cardArealoading = false;
        console.log(error);
      }
    },
    async fetchIncomeCard(type) {
      const res = await getIncomeCard({ card_type: type });
      type == 1
        ? (this.storDetailCard1 = res.data)
        : (this.storDetailCard2 = res.data);
    },
    openDetailCard(type) {
      if (type == 1) {
        this.cardDetail = this.storDetailCard1 || {};
        this.dialogTitle = '本月';
        this.monthDClick();
      } else {
        this.cardDetail = this.storDetailCard2 || {};
        this.dialogTitle = '累计';
        this.allDClick();
      }
      this.detailDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.overview-data {
  .data-screening {
    .date-wrap {
      display: flex;
      justify-content: flex-end;
      font-size: 16px;
      color: #8c8c8c;
      margin-bottom: 15px;
    }
    .data-wrap {
      display: flex;
      justify-content: flex-start;
      margin-left: -18px;
      flex-wrap: wrap;
      .card {
        width: 480px;
        height: 120px;
        // background: #fafafa;
        border-radius: 8px;
        display: flex;
        align-items: center;
      }
      .data-item {
        display: flex;
        flex-direction: column;
        //margin-left: 20px;
        margin-left: 10px;
        cursor: pointer;
        justify-content: space-around;
        background: #fafafa;
        //margin-right: 10px;
        border-radius: 8px;
        margin-bottom: 24px;
        width: 190px;
        height: 120px;
        padding: 13px 18px;
        &:hover {
          background: #fffaed;
          border: 1px solid #ffc973;
        }
        .item-title {
          font-size: 16px;
        }
        .figure-detail {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .item-figure {
            color: $--color-primary;
            font-size: 24px;
          }
          .item-detail {
            color: #2b6ddf;
            cursor: pointer;
          }
        }
        .item-prev {
          color: #8c8c8c;
          font-size: 16px;
        }
      }
      .data-item:first-child {
        margin-left: 16px;
      }

      .data-item.active {
        background-color: #fffaed;
      }
      .data-line {
        width: 1px;
        height: 70px;
        background: #d9d9d9;
      }
    }
    .data-explain {
      margin-top: 30px;
      color: #8c8c8c;
      p {
        margin: 8px;
      }
      .detail-explain {
        color: #2b6ddf;
        cursor: pointer;
      }
    }
    .img-no-data {
      margin-top: 50px;
      text-align: center;
      background: url('../../../../assets/images/img_bg_charts_no_data.png')
        no-repeat;
      height: 218px;
      img {
        margin-top: -10px;
        width: 160px;
        height: 160px;
      }
      p {
        font-size: 16px;
        color: #8c8c8c;
      }
    }
  }

  .dialog-wrap {
    padding: 0 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .dialog-total {
      width: 100%;
      font-size: 40px;
      color: $--color-primary;
      margin-top: 21px;
      text-align: center;
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      margin-bottom: 24px;
    }

    .dialog-detail {
      padding-top: 14px;
      width: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .income-list {
        font-size: 16px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin: 8px;
        .income-list-name {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .icon {
            width: 18px;
            height: 18px;
            margin-left: 6px;
          }
        }
      }
      p {
        margin-top: 52px;
      }
      a {
        color: #2b6ddf;
        text-decoration: none;
        margin-top: 30px;
      }
    }
  }
}
::v-deep .el-dialog__body {
  margin: 0;
  color: #262626;
}
::v-deep .el-dialog {
  border-radius: 8px;
}
</style>
